{
	"success": {
		"title": "Paiement confirmé",
		"message": "Votre paiement a été traité avec succès. Vous pouvez fermer cette page."
	},
	"pending": {
		"title": "Paiement en cours",
		"message": "Nous confirmons votre paiement. Cela peut prendre quelques instants."
	},
	"failed": {
		"title": "Paiement non abouti",
		"message": "Nous n'avons pas pu traiter votre paiement. Réessayez ou utilisez un autre moyen."
	},
	"canceled": {
		"title": "Paiement annulé",
		"message": "Le paiement a été annulé."
	},
	"unknown": {
		"title": "Statut indisponible",
		"message": "Nous n'avons pas pu identifier le statut de votre paiement."
	}
}
